import { useRouter } from 'next/router';

import { TranslationService } from '@/utils/services/TranslationService';

// Libs
import { ANALYZE_REACH, ANALYZE_REACH_IMPRESSIONS } from '@/lib/routes/privateRoutes';

// Components
import LoaderPage from '@/components/base/Loader/LoaderPage';
import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';

const Page = () => {
    const router = useRouter();

    router.push(ANALYZE_REACH_IMPRESSIONS);
    return <LoaderPage />;
};

const Reach = () => (
    <WrapperSwitchLayout>
        <Page />
    </WrapperSwitchLayout>
);

export const getStaticProps = TranslationService.getTranslationMessagesFromRoute(ANALYZE_REACH);

export default Reach;
